module.exports = __webpack_public_path__ + "img/ico-pdf-big.fd72695e.svg";